import Footer from "../components/common/Footer.jsx";
import { Link } from "react-router-dom";
import Header from "../components/common/Header.jsx";
import css from "../components/common/innerPageStyles.js";

// TODO: replace with the real App Store URL
const APP_STORE_URL = "#";

const jsonLd = `{
 "@context": "https://schema.org",
 "@graph": [
  {
   "@type": "Organization",
   "@id": "https://www.futurefamilyai.com/#org",
   "name": "FutureFamilyAI",
   "url": "https://www.futurefamilyai.com/",
   "logo": "https://www.futurefamilyai.com/wp-content/uploads/futurefamilyai-logo.png",
   "parentOrganization": {
    "@type": "Organization",
    "name": "HelixFoundry, Inc."
   },
   "sameAs": [
    "[SOCIAL_PROFILE_URLS]"
   ]
  },
  {
   "@type": "MedicalWebPage",
   "@id": "https://www.futurefamilyai.com/monitoring/blood-pressure-chart-pregnancy-trimester/#webpage",
   "url": "https://www.futurefamilyai.com/monitoring/blood-pressure-chart-pregnancy-trimester/",
   "name": "Normal Pregnancy BP by Trimester | FutureFamilyAI",
   "description": "How blood pressure typically changes across trimesters, which readings are considered elevated, and why your own trend matters more than a chart.",
   "inLanguage": "en-US",
   "datePublished": "2026-10-20",
   "dateModified": "2026-10-20",
   "author": {
    "@type": "Person",
    "name": "Dr. Kulsoom Baloch, MBBS, MPH",
    "jobTitle": "Clinical Protocol Author, FutureFamilyAI",
    "url": "https://www.futurefamilyai.com/about/#kulsoom-baloch",
    "worksFor": {
     "@type": "Organization",
     "name": "FutureFamilyAI"
    }
   },
   "reviewedBy": {
    "@type": "Person",
    "name": "Dr. Rashmi Gulati, MD",
    "jobTitle": "Medical Director, Patients Medical",
    "url": "https://www.futurefamilyai.com/about/#rashmi-gulati",
    "worksFor": {
     "@type": "Organization",
     "name": "Patients Medical"
    }
   },
   "lastReviewed": "2026-10-20",
   "publisher": {
    "@id": "https://www.futurefamilyai.com/#org"
   },
   "speakable": {
    "@type": "SpeakableSpecification",
    "cssSelector": [
     ".speakable-content"
    ]
   }
  },
  {
   "@type": "BreadcrumbList",
   "itemListElement": [
    {
     "@type": "ListItem",
     "position": 1,
     "name": "Home",
     "item": "https://www.futurefamilyai.com/"
    },
    {
     "@type": "ListItem",
     "position": 2,
     "name": "Blood Pressure During Pregnancy",
     "item": "https://www.futurefamilyai.com/monitoring/blood-pressure-pregnancy/"
    },
    {
     "@type": "ListItem",
     "position": 3,
     "name": "Blood Pressure Chart by Trimester",
     "item": "https://www.futurefamilyai.com/monitoring/blood-pressure-chart-pregnancy-trimester/"
    }
   ]
  },
  {
   "@type": "FAQPage",
   "mainEntity": [
    {
     "@type": "Question",
     "name": "What is normal blood pressure when pregnant?",
     "acceptedAnswer": {
      "@type": "Answer",
      "text": "Many clinicians consider readings below 140/90 within the expected range, but your target depends on your history."
     }
    },
    {
     "@type": "Question",
     "name": "Does blood pressure go down in the second trimester?",
     "acceptedAnswer": {
      "@type": "Answer",
      "text": "Often, yes. It typically rises again in the third trimester."
     }
    },
    {
     "@type": "Question",
     "name": "Is 130/85 high during pregnancy?",
     "acceptedAnswer": {
      "@type": "Answer",
      "text": "It may be within range for some people and a change for others. Discuss it with your clinician, especially if it's a rise from your baseline."
     }
    },
    {
     "@type": "Question",
     "name": "Is low blood pressure in pregnancy dangerous?",
     "acceptedAnswer": {
      "@type": "Answer",
      "text": "Mild low blood pressure is common. Dizziness or fainting should be discussed with your clinician."
     }
    },
    {
     "@type": "Question",
     "name": "What blood pressure requires hospitalization in pregnancy?",
     "acceptedAnswer": {
      "@type": "Answer",
      "text": "Readings of 160/110 or higher, or severe symptoms, need urgent evaluation."
     }
    },
    {
     "@type": "Question",
     "name": "Should I track systolic or diastolic?",
     "acceptedAnswer": {
      "@type": "Answer",
      "text": "Both. Your clinician will interpret them together."
     }
    },
    {
     "@type": "Question",
     "name": "Does FutureFamilyAI replace my doctor or prenatal visits?",
     "acceptedAnswer": {
      "@type": "Answer",
      "text": "No. FutureFamilyAI is a wellness tool that organizes your readings and symptoms so your own clinician has more context between visits. Your care team makes every medical decision, and you should keep all scheduled appointments."
     }
    },
    {
     "@type": "Question",
     "name": "How much does FutureFamilyAI cost?",
     "acceptedAnswer": {
      "@type": "Answer",
      "text": "Eligible participants pay no subscription fee during the free pilot through December 31, 2026. After that, Complete Monitoring is $39.99/month or $399/year. A compatible phone, validated cuff and (for wearable trends) a smartwatch are purchased separately."
     }
    }
   ]
  }
 ]
}`;

export default function MonitoringBloodPressureChartPregnancyTrimesterPage() {
  return (
    <div className="wrapper2">
      <style>{css}</style>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: jsonLd }}
      />
      <Header />
      <main className="ffh-home">
        <section className="ffh-page-hero">
          <div className="ffh-wrap">
            <nav className="ffh-crumbs" aria-label="Breadcrumb">
              <Link to="/">Home</Link>
              <span>›</span>
              <Link to="/monitoring/blood-pressure-pregnancy">
                Blood Pressure During Pregnancy
              </Link>
              <span>›</span>
              <span>Blood Pressure Chart by Trimester</span>
            </nav>
            <aside className="ffh-facts" aria-label="Fast facts">
              <div className="ffh-facts-title">
                <svg
                  viewBox="0 0 24 24"
                  width="16"
                  height="16"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  aria-hidden="true"
                >
                  <circle cx="12" cy="12" r="9" />
                  <path d="M12 11v6M12 7.5v.5" />
                </svg>{" "}
                Fast facts
              </div>
              <p className="ffh-q">
                Blood pressure in pregnancy commonly dips in the first and
                second trimesters and returns toward pre-pregnancy levels in the
                third.
              </p>
              <details>
                <summary>
                  More fast facts: audience, key stat, safety, cost
                </summary>
                <dl>
                  <div>
                    <dt>Who it&apos;s for</dt>
                    <dd>Expecting mothers</dd>
                  </div>
                  <div>
                    <dt>Key stat</dt>
                    <dd>
                      In pregnancy, a blood pressure of 160 systolic or 110
                      diastolic or higher is in the severe range and needs
                      urgent evaluation. (ACOG Practice Bulletin No. 222, 2020)
                    </dd>
                  </div>
                  <div>
                    <dt>Safety &amp; oversight</dt>
                    <dd>
                      Wellness tool, not a medical device. Orange and Red
                      statuses reviewed by a real care team. Not for emergencies
                      — call 911.
                    </dd>
                  </div>
                  <div>
                    <dt>Why FutureFamilyAI</dt>
                    <dd>
                      Your baseline, not a generic chart · Trends over single
                      numbers · Thresholds set by your clinician
                    </dd>
                  </div>
                  <div>
                    <dt>Cost</dt>
                    <dd>
                      Free pilot through Dec 31, 2026; then $39.99/mo or
                      $399/yr. Devices separate.
                    </dd>
                  </div>
                  <div>
                    <dt>Get started</dt>
                    <dd>
                      Download on the App Store, or request free pilot access at
                      futurefamilyai.com/contact/
                    </dd>
                  </div>
                </dl>
              </details>
            </aside>
            <p className="ffh-entity">
              FutureFamilyAI is a physician-connected pregnancy and
              family-planning wellness app that turns home blood pressure
              readings from a validated cuff, smartwatch wellness trends and
              symptom notes into a simple color status your care team can review
              between visits. Its monitoring protocol was developed by Dr.
              Kulsoom Baloch, MBBS, MPH, using ACOG, SMFM, ISSHP and AHA
              guidance, and every page is medically reviewed by Dr. Rashmi
              Gulati, MD, Medical Director of Patients Medical (Manhattan, since
              1974). FutureFamilyAI is a product of HelixFoundry, Inc., and is
              used by Surrogacy4All to support its gestational surrogates.
            </p>
            <span className="ffh-eyebrow">BLOOD PRESSURE GUIDE</span>
            <h1>Normal Blood Pressure in Pregnancy by Trimester, Explained</h1>
            <p className="ffh-answer speakable-content">
              Blood pressure in pregnancy commonly dips in the first and second
              trimesters and returns toward pre-pregnancy levels in the third.
              Readings of 140/90 or higher are generally considered elevated,
              and 160/110 or higher is severe. There is no single
              &apos;normal&apos; number for every trimester — your clinician
              interprets readings against your history. FutureFamilyAI tracks
              your personal trend. See your baseline.
            </p>
            <div className="ffh-byline">
              <span>
                Written by{" "}
                <b>
                  <Link to="/about#kulsoom-baloch">
                    Dr. Kulsoom Baloch, MBBS, MPH
                  </Link>
                </b>
              </span>
              <span>
                Medically reviewed by{" "}
                <b>
                  <Link to="/about#rashmi-gulati">Dr. Rashmi Gulati, MD</Link>
                </b>
              </span>
              <span>Published October 2026 · Last updated October 2026</span>
            </div>
            <div className="ffh-cta-row">
              <a className="ffh-btn ffh-primary" href={APP_STORE_URL}>
                <svg
                  viewBox="0 0 24 24"
                  width="18"
                  height="18"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  aria-hidden="true"
                >
                  <path
                    d="M16 3c-1 .1-2.2.8-2.8 1.6-.6.7-1 1.8-.9 2.8 1.1.1 2.2-.6 2.8-1.4.6-.8 1-1.9.9-3zM19.5 16.6c-.5 1.1-.8 1.6-1.4 2.6-.9 1.4-2.2 3-3.7 3-1.4 0-1.7-.9-3.6-.9s-2.3.9-3.6.9c-1.6 0-2.8-1.5-3.7-2.9C1.1 15.4.8 10.8 2.4 8.4c1.1-1.7 2.9-2.7 4.6-2.7 1.7 0 2.8.9 4.2.9 1.4 0 2.2-.9 4.2-.9 1.5 0 3.1.8 4.2 2.2-3.7 2-3.1 7.3-.1 8.7z"
                    fill="currentColor"
                    stroke="none"
                  />
                </svg>
                Download on the App Store
              </a>
              <Link className="ffh-btn ffh-ghost" to="/contact-us?type=member">
                Request Free Pilot Access
              </Link>
            </div>
          </div>
        </section>
        <section className="ffh-band" style={{ paddingBlock: "40px 64px" }}>
          <div className="ffh-wrap ffh-layout">
            <div className="ffh-prose">
              <figure
                className="ffh-photo"
                role="img"
                aria-label="Illustration of how blood pressure changes across the three trimesters of pregnancy"
              >
                <figcaption>
                  <b>Photo slot</b> · Editorial illustration (flat, geometric,
                  brand palette) of a gentle wave line across three trimester
                  segments with a small figure of a pregnant woman. No numbers
                  or labels baked in — labels added as live HTML.
                  <br />
                  <b>Alt:</b> Illustration of how blood pressure changes across
                  the three trimesters of pregnancy
                </figcaption>
              </figure>
              <section className="ffh-keystats" id="key-stats">
                <h2>Key statistics</h2>
                <ul>
                  <li>
                    In pregnancy, a blood pressure of 160 systolic or 110
                    diastolic or higher is in the severe range and needs urgent
                    evaluation.
                    <cite>
                      Source:{" "}
                      <a href="https://www.acog.org/clinical/clinical-guidance/practice-bulletin/articles/2020/06/gestational-hypertension-and-preeclampsia">
                        ACOG Practice Bulletin No. 222, 2020
                      </a>
                    </cite>
                  </li>
                  <li>
                    The USPSTF recommends screening for hypertensive disorders
                    of pregnancy with blood pressure measurements throughout
                    pregnancy.
                    <cite>
                      Source:{" "}
                      <a href="https://www.uspreventiveservicestaskforce.org/uspstf/recommendation/hypertensive-disorders-pregnancy-screening">
                        USPSTF, 2023
                      </a>
                    </cite>
                  </li>
                </ul>
              </section>
              <section id="s1">
                <h2>Typical pattern</h2>
                <ul>
                  <li>First trimester: may start to dip.</li>
                  <li>Second trimester: often at its lowest.</li>
                  <li>Third trimester: rises back toward baseline.</li>
                  <li>Postpartum: can rise in the first days after birth.</li>
                </ul>
              </section>
              <section id="s2">
                <h2>General reference ranges</h2>
                <ul>
                  <li>
                    Below 120/80 — commonly considered normal outside pregnancy.
                  </li>
                  <li>
                    140/90 or higher — elevated in pregnancy; contact your
                    clinician.
                  </li>
                  <li>160/110 or higher — severe range; urgent evaluation.</li>
                </ul>
              </section>
              <div className="ffh-inline-cta">
                <p>Free pilot enrollment is open through December 31, 2026.</p>
                <a className="ffh-btn ffh-primary ffh-sm" href={APP_STORE_URL}>
                  <svg
                    viewBox="0 0 24 24"
                    width="18"
                    height="18"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    aria-hidden="true"
                  >
                    <path
                      d="M16 3c-1 .1-2.2.8-2.8 1.6-.6.7-1 1.8-.9 2.8 1.1.1 2.2-.6 2.8-1.4.6-.8 1-1.9.9-3zM19.5 16.6c-.5 1.1-.8 1.6-1.4 2.6-.9 1.4-2.2 3-3.7 3-1.4 0-1.7-.9-3.6-.9s-2.3.9-3.6.9c-1.6 0-2.8-1.5-3.7-2.9C1.1 15.4.8 10.8 2.4 8.4c1.1-1.7 2.9-2.7 4.6-2.7 1.7 0 2.8.9 4.2.9 1.4 0 2.2-.9 4.2-.9 1.5 0 3.1.8 4.2 2.2-3.7 2-3.1 7.3-.1 8.7z"
                      fill="currentColor"
                      stroke="none"
                    />
                  </svg>
                  Download on the App Store
                </a>
              </div>
              <section id="s3">
                <h2>Why your trend matters</h2>
                <p>
                  A rise from your own baseline can be meaningful even below
                  140/90, and a single high reading may need repeating.
                  That&apos;s why FutureFamilyAI compares readings to your
                  baseline.
                </p>
              </section>
              <section id="faq">
                <h2>Frequently asked questions</h2>
                <div className="ffh-faq">
                  <details open>
                    <summary>
                      What is normal blood pressure when pregnant?
                    </summary>
                    <div className="ffh-ans speakable-content">
                      <p>
                        Many clinicians consider readings below 140/90 within
                        the expected range, but your target depends on your
                        history.
                      </p>
                    </div>
                  </details>
                  <details>
                    <summary>
                      Does blood pressure go down in the second trimester?
                    </summary>
                    <div className="ffh-ans speakable-content">
                      <p>
                        Often, yes. It typically rises again in the third
                        trimester.
                      </p>
                    </div>
                  </details>
                  <details>
                    <summary>Is 130/85 high during pregnancy?</summary>
                    <div className="ffh-ans speakable-content">
                      <p>
                        It may be within range for some people and a change for
                        others. Discuss it with your clinician, especially if
                        it&apos;s a rise from your baseline.
                      </p>
                    </div>
                  </details>
                  <details>
                    <summary>
                      Is low blood pressure in pregnancy dangerous?
                    </summary>
                    <div className="ffh-ans">
                      <p>
                        Mild low blood pressure is common. Dizziness or fainting
                        should be discussed with your clinician.
                      </p>
                    </div>
                  </details>
                  <details>
                    <summary>
                      What blood pressure requires hospitalization in pregnancy?
                    </summary>
                    <div className="ffh-ans">
                      <p>
                        Readings of 160/110 or higher, or severe symptoms, need
                        urgent evaluation.
                      </p>
                    </div>
                  </details>
                  <details>
                    <summary>Should I track systolic or diastolic?</summary>
                    <div className="ffh-ans">
                      <p>Both. Your clinician will interpret them together.</p>
                    </div>
                  </details>
                  <details>
                    <summary>
                      Does FutureFamilyAI replace my doctor or prenatal visits?
                    </summary>
                    <div className="ffh-ans">
                      <p>
                        No. FutureFamilyAI is a wellness tool that organizes
                        your readings and symptoms so your own clinician has
                        more context between visits. Your care team makes every
                        medical decision, and you should keep all scheduled
                        appointments.
                      </p>
                    </div>
                  </details>
                  <details>
                    <summary>How much does FutureFamilyAI cost?</summary>
                    <div className="ffh-ans">
                      <p>
                        Eligible participants pay no subscription fee during the
                        free pilot through December 31, 2026. After that,
                        Complete Monitoring is $39.99/month or $399/year. A
                        compatible phone, validated cuff and (for wearable
                        trends) a smartwatch are purchased separately.
                      </p>
                    </div>
                  </details>
                </div>
                <div className="ffh-cta-row">
                  <a className="ffh-btn ffh-primary" href={APP_STORE_URL}>
                    <svg
                      viewBox="0 0 24 24"
                      width="18"
                      height="18"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      aria-hidden="true"
                    >
                      <path
                        d="M16 3c-1 .1-2.2.8-2.8 1.6-.6.7-1 1.8-.9 2.8 1.1.1 2.2-.6 2.8-1.4.6-.8 1-1.9.9-3zM19.5 16.6c-.5 1.1-.8 1.6-1.4 2.6-.9 1.4-2.2 3-3.7 3-1.4 0-1.7-.9-3.6-.9s-2.3.9-3.6.9c-1.6 0-2.8-1.5-3.7-2.9C1.1 15.4.8 10.8 2.4 8.4c1.1-1.7 2.9-2.7 4.6-2.7 1.7 0 2.8.9 4.2.9 1.4 0 2.2-.9 4.2-.9 1.5 0 3.1.8 4.2 2.2-3.7 2-3.1 7.3-.1 8.7z"
                        fill="currentColor"
                        stroke="none"
                      />
                    </svg>
                    Download on the App Store
                  </a>
                  <Link
                    className="ffh-btn ffh-ghost"
                    to="/contact-us?type=member"
                  >
                    Request Free Pilot Access
                  </Link>
                </div>
              </section>
              <section className="ffh-authorbox">
                <span className="ffh-ph">KB</span>
                <div className="ffh-stack" style={{ gap: "6px" }}>
                  <h3>Dr. Kulsoom Baloch, MBBS, MPH</h3>
                  <p>
                    Clinical Protocol Author, FutureFamilyAI. Dr. Kulsoom
                    Baloch, MBBS, MPH, is the clinical protocol author for
                    FutureFamilyAI and a published researcher in reproductive
                    and maternal health. She developed the app&apos;s monitoring
                    protocol using ACOG, SMFM, ISSHP and AHA guidance.
                  </p>
                  <p>
                    Medically reviewed by{" "}
                    <Link to="/about#rashmi-gulati">Dr. Rashmi Gulati, MD</Link>
                    , Medical Director, Patients Medical. Last updated: October
                    2026.
                  </p>
                </div>
              </section>
              <section>
                <h2>Keep reading</h2>
                <div className="ffh-related">
                  <Link to="/monitoring/blood-pressure-pregnancy">
                    Blood Pressure During Pregnancy →
                  </Link>
                  <Link to="/monitoring/gestational-hypertension-symptoms">
                    Gestational Hypertension Symptoms →
                  </Link>
                  <Link to="/monitoring/preeclampsia-warning-signs">
                    Preeclampsia Warning Signs →
                  </Link>
                  <Link to="/monitoring/home-blood-pressure-cuff-pregnancy">
                    Home Blood Pressure Cuffs →
                  </Link>
                  <Link to="/monitoring/when-to-call-doctor-blood-pressure-pregnancy">
                    When to Call Your Doctor About BP →
                  </Link>
                  <Link to="/how-it-works">How it works →</Link>
                  <Link to="/pricing">Pricing &amp; free pilot →</Link>
                  <Link to="/privacy-safety">Privacy &amp; safety →</Link>
                  <Link to="/faq">FAQ →</Link>
                </div>
              </section>
              <p className="ffh-notice">
                FutureFamilyAI is a wellness and awareness tool. It is not a
                medical device, is not FDA-cleared, does not diagnose or treat
                any condition, and is not monitored in real time. It supports —
                and does not replace — your prenatal care. In an emergency, call
                911.
              </p>
            </div>
            <aside className="ffh-aside">
              <div className="ffh-toc">
                <b>What you will learn</b>
                <ol>
                  <li>
                    <a href="#s1">Typical pattern</a>
                  </li>
                  <li>
                    <a href="#s2">General reference ranges</a>
                  </li>
                  <li>
                    <a href="#s3">Why your trend matters</a>
                  </li>
                  <li>
                    <a href="#faq">Frequently asked questions</a>
                  </li>
                </ol>
              </div>
              <div className="ffh-cta-card">
                <b>Join the free pilot</b>
                <span>No subscription fee through Dec 31, 2026.</span>
                <a className="ffh-btn ffh-primary ffh-sm" href={APP_STORE_URL}>
                  <svg
                    viewBox="0 0 24 24"
                    width="18"
                    height="18"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    aria-hidden="true"
                  >
                    <path
                      d="M16 3c-1 .1-2.2.8-2.8 1.6-.6.7-1 1.8-.9 2.8 1.1.1 2.2-.6 2.8-1.4.6-.8 1-1.9.9-3zM19.5 16.6c-.5 1.1-.8 1.6-1.4 2.6-.9 1.4-2.2 3-3.7 3-1.4 0-1.7-.9-3.6-.9s-2.3.9-3.6.9c-1.6 0-2.8-1.5-3.7-2.9C1.1 15.4.8 10.8 2.4 8.4c1.1-1.7 2.9-2.7 4.6-2.7 1.7 0 2.8.9 4.2.9 1.4 0 2.2-.9 4.2-.9 1.5 0 3.1.8 4.2 2.2-3.7 2-3.1 7.3-.1 8.7z"
                      fill="currentColor"
                      stroke="none"
                    />
                  </svg>
                  Download on the App Store
                </a>
              </div>
            </aside>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}
